import styles from "./Founders.module.scss";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { isRTL } from "@cs/lib/getDirFromLocale";

const FounderKeys = ["eric", "isabel"];

export const Founders = () => {
  const router = useRouter()
  const { t } = useTranslation("about");

  const IMGS: string[] = [
    "/img/about/Eric.jpeg",
    "/img/about/Isabel.jpeg",
  ];
  return (
    <div className={styles.founders}>
      <h1 className={styles.title}>{t("founders.title")}</h1>
      <div className={styles.foundersSection}>
        {FounderKeys.map((founderId, i) => (
          <div key={founderId} className={styles.founderSection}>
            <div className={styles.founderImageContainer}>
              <Image
                alt={t(`founders.people.${founderId}.name`)}
                className={styles.founderImage}
                src={IMGS[i]}
                width={300}
                height={300}/>
            </div>
            <div className={
              isRTL(router.locale) ?
                styles.founderText_rtl :
                styles.founderText
            }>
              <h2
                className={styles.name}>{t(`founders.people.${founderId}.name`)}</h2>
              <h3 className={styles.role}>
                {t(`founders.people.${founderId}.role`)}</h3>
              <hr></hr>
              <p
                className={styles.bio}>{t(`founders.people.${founderId}.bio`)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};